import { Component, OnInit } from '@angular/core';
import { ProgressBarService } from './progress-bar.service';
import { ProgressStep } from '../../model/progress-step.model';
import { ProgressState } from '../../model/progress-state.enum';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {

  public ProgressState = ProgressState;

  public get Steps(): ProgressStep[] {
    return this.service.Steps;
  }

  public get Count(): number {
    return this.service.Steps.length + (this.service.HasLastStep ? 0 : 1);
  }

  constructor(
    public service: ProgressBarService
  ) {
  }

  ngOnInit() {
  }

}
